import axios from 'axios';

export async function fetchRoomDescription(room: string): Promise<string> {
  try {
    const response = await axios.get('https://frappe.kry.bz/api/method/bmapp.utils.api.get_room_description', {
      params: { room }
    });
    return response.data.message || 'Keine Beschreibung verfügbar';
  } catch (error) {
    console.error('Error fetching room description:', error);
    
    // Always return maintenance message on any error
    return 'Unser System befindet sich gerade in der Wartung, bitte später nochmal versuchen';
  }
}